import React, { useContext } from "react";
import style from "./index.module.scss";
import Resource from "./components/Resource";
import Activity from "./components/Activity";
import useRequest from "../../../utils/useRequest";
import { CourseContext } from "../Store";
import { getProjectionScreenReport } from "../../../service/report";
import { Spin } from "antd";
import useCurrentDate from "../../../utils/useCurrentDate";
import Config from "../../../config";

export default function Report() {
    const { course } = useContext(CourseContext);
    const { batchNo } = useCurrentDate();
    const [report, { loading }] = useRequest(
        () =>
            getProjectionScreenReport({
                batchNo,
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                customerCode: Config.CustomCode,
                weekTimeId: course.weekTimeId
            }),
        {},
        [course.weekTimeId]
    );

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                {report && (
                    <>
                        <Resource resourceData={report} />
                        <Activity activityData={report} />
                    </>
                )}
            </Spin>
        </div>
    );
}
